import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IExamSession, IExamStudentResult, IExamSupervisor, IScan, IScans } from '../../_Models/iexam-session';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ExamSessionService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiEndpoint}/${environment.apiEndpointLang}/${environment.apiEndpointApp}`;

  GetALLExamSessions(past: boolean = false): Observable<IExamSession[]> {
    if (!past)
      return this.http.get<IExamSession[]>(`${this.baseUrl}/ExaScan/GetMyUpcomingExams`);
    else
      return this.http.get<IExamSession[]>(`${this.baseUrl}/ExaScan/GetMyPastExams`);
  }

  GetAllStudentsForExam(examSessionId: string) {
    return this.http.get<IExamStudentResult[]>(`${this.baseUrl}/ExaScan/GetExamStudents?examenSlotId=${examSessionId}`);
  }

  AddScansForExam(scans: IScans) {
    return this.http.post(`${this.baseUrl}/ExaScan/ProcessScans`, scans);
  }

  GetScansForExam(examSessionId: string) {
    return this.http.get<IScan[]>(`${this.baseUrl}/ExaScan/GetExamScans?examenSlotId=${examSessionId}`);
  }

  GetAllSupervisorsForExam(examSessionId: string) {
    return this.http.get<IExamSupervisor[]>(`${this.baseUrl}/ExaScan/GetExamScanners?examenSlotId=${examSessionId}`);
  }

  DownloadExamReport(examSessionId: string)  {
    return this.http.get(`${this.baseUrl}/ExaScan/DownloadExamReport?examenSlotId=${examSessionId}`, {
      responseType: 'blob'
    });
  }

  RemoveSupervisorFromExam(examSessionId: string, userId: string) {
    const body = {
      examenSlotId: examSessionId,
      userId: userId
    };

    return this.http.request('delete', `${this.baseUrl}/ExaScan/RemoveExamSupervisor`, { body });
  }

  AddSupervisorForExam(examSessionId: string, username: string) {
    const body = {
      examenSlotId: examSessionId,
      supervisorUsername: username
    };

    return this.http.post(`${this.baseUrl}/ExaScan/AddExamSupervisor`, body);
  }

}
